import React, { createContext, useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { wlpData } from '../utils/wlp';

export const StoreContext = createContext(null);

const StoreProvider = ({ children }) => {
  // Define state variables and their setters for various options and data
  const [wlpConfig, setWlpConfig] = useState({});

  const [accountDetails, setAccountDetails] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [traderDetails, setTraderDetails] = useState({});
  const [userRoles, setUserRoles] = useState([]);

  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentStatus, setShipmentStatus] = useState([]);
  const [shipmentStatusFilter, setShipmentStatusFilter] = useState({});
  const [shipmentStatusFilterData, setShipmentStatusFilterData] = useState({});
  const [shipmentStatusData, setShipmentStatusData] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [eoriCompany, setEoriCompany] = useState(() => sessionStorage.getItem('eoriSelectedCompanyId') || '');
  const [shipmentTotalCount, setShipmentTotalCount] = useState(0);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');

  const [isLoadingSSO, setIsLoadingSSO] = useState(false);
  const [isSSOUserWithNoCompany, setIsSSOUserWithNoCompany] = useState(false);
  const [ssoUserDetails, setSSOUserDetails] = useState({});
  const [maintenanceRefresh, setMaintenanceRefresh] = useState(false);

  const showError = (message) => {
    setErrorSnackbarMessage(message);
    setShowErrorSnackbar(true);
  };

  useEffect(() => {
    let config = wlpData[window.location.host] || wlpData.default;

    if (process.env.REACT_APP_SITE_TEMPLATE === '360pay') {
      // for testing on local environments
      config = wlpData['ensgb-360pay-dev.azurewebsites.net'];
    }

    setWlpConfig(config);
  }, []);

  const store = useMemo(
    () => ({
      wlpConfig: [wlpConfig, setWlpConfig],
      accountDetails: [accountDetails, setAccountDetails],
      userDetails: [userDetails, setUserDetails],
      traderDetails: [traderDetails, setTraderDetails],
      userRoles: [userRoles, setUserRoles],

      shipmentData: [shipmentData, setShipmentData],
      shipmentStatus: [shipmentStatus, setShipmentStatus],
      shipmentStatusFilter: [shipmentStatusFilter, setShipmentStatusFilter],
      shipmentStatusFilterData: [shipmentStatusFilterData, setShipmentStatusFilterData],
      shipmentStatusData: [shipmentStatusData, setShipmentStatusData],
      companyList: [companyList, setCompanyList],
      eoriCompany: [eoriCompany, setEoriCompany],
      shipmentTotalCount: [shipmentTotalCount, setShipmentTotalCount],
      isReadOnly: [isReadOnly, setIsReadOnly],
      showErrorSnackbar: [showErrorSnackbar, setShowErrorSnackbar],
      errorSnackbarMessage: [errorSnackbarMessage, setErrorSnackbarMessage],
      showError,
      hideError: () => setShowErrorSnackbar(false),
      isLoadingSSO: [isLoadingSSO, setIsLoadingSSO],
      ssoUserDetails: [ssoUserDetails, setSSOUserDetails],
      isSSOUserWithNoCompany: [isSSOUserWithNoCompany, setIsSSOUserWithNoCompany],
      maintenanceRefresh: [maintenanceRefresh, setMaintenanceRefresh],
    }),
    [
      wlpConfig,
      setWlpConfig,
      accountDetails,
      setAccountDetails,
      userDetails,
      setUserDetails,
      traderDetails,
      setTraderDetails,
      userRoles,
      setUserRoles,

      shipmentData,
      setShipmentData,
      shipmentStatus,
      setShipmentStatus,
      shipmentStatusFilter,
      setShipmentStatusFilter,
      shipmentStatusFilterData,
      setShipmentStatusFilterData,
      shipmentStatusData,
      setShipmentStatusData,
      companyList,
      setCompanyList,
      eoriCompany,
      setEoriCompany,
      shipmentTotalCount,
      setShipmentTotalCount,
      isReadOnly,
      setIsReadOnly,
      showErrorSnackbar,
      setShowErrorSnackbar,
      errorSnackbarMessage,
      setErrorSnackbarMessage,
      showError,
      setShowErrorSnackbar,
      isLoadingSSO,
      setIsLoadingSSO,
      ssoUserDetails,
      setSSOUserDetails,
      isSSOUserWithNoCompany,
      setIsSSOUserWithNoCompany,
      maintenanceRefresh,
      setMaintenanceRefresh,
    ]
  );

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export default StoreProvider;
StoreProvider.propTypes = {
  children: PropTypes.node,
};
